import React from 'react';
import styles from './BannerFullWidthAnimationLargeText.module.scss';
import GrandPage from '../../Components/GrandPage/GrandPage';
import TitleComponent from '../../Components/TitleComponent/TItleComponent';
import ImagePoints from '../../Components/ImageComponent/ImagePoints';

const BannerFullWidthAnimationLargeText = ({ api, type }) => {
  const imgAlignClass = api?.attributes?.imgalign;
  let alignmentClasses = '';

  switch (imgAlignClass) {
    case 'left':
      alignmentClasses = styles.LeftPositionMob;
      break;
    case 'right':
      alignmentClasses = styles.rightPositionMob;
      break;
    case 'center':
      alignmentClasses = styles.centerPositionMob;
      break;
    default:
      alignmentClasses = '';
  }

  return (
    <section
      id={api?.id}
      className={`wrapper fullImage biggerAnim mb-small ${
        api?.attributes?.image?.imagePointsYellow || api?.attributes?.image?.imagePointsCoordinates ? styles.scrollBtn : ''
      }`}
    >
      <div className={styles.topMainContainer}>
      <div
          className={`${styles.topContainer} ${
            api?.attributes?.image?.imagePointsYellow || api?.attributes?.image?.imagePointsCoordinates ? '' : styles.noButton
          } ${alignmentClasses} ${
            api?.attributes?.image?.imagePointsYellow || api?.attributes?.image?.imagePointsCoordinates ? styles.scrollImg : ''
          }`}
        >
          {api.attributes.image && <ImagePoints properties={api.attributes} />}
        </div>
        <TitleComponent
          type={`afterBg ${type} withTitleOverlay`}
          properties={api.attributes}
          animationData={{ animation: 'fade-right', animationDuration: '1000', animationEasing: 'easy-in-out' }}
        />
      </div>

      <div className={styles.downContainer}>
        <GrandPage
          animationData={{ animation: 'fade-up', animationDuration: '500', animationEasing: 'easy-in-out' }}
          properties={api.attributes}
          blockID={api.id}
        />
      </div>
    </section>
  );
};

export default BannerFullWidthAnimationLargeText;
